import attachmentUrl from './attachment.html';
class AttachmentCtrl {
  constructor($uibModal, $sce, $scope, $element, $window, AttachmentUtils) {
    'ngInject';

    Object.assign(this, { $uibModal, $sce, $scope, $element, $window, AttachmentUtils });
  }

  async $onInit() {
    this.marginLeft = Number(
      this.$window.getComputedStyle(this.$element[0]).marginLeft.slice(0, -2)
    );
    // processAttachment is async (it resolves the CDN-resize feature flag);
    // without the await, this.attachment would be a Promise and the template's
    // ctrl.attachment.thumb bindings would never render.
    this.attachment = await this.AttachmentUtils.processAttachment(
      this.src,
      this.total,
      this.width,
      this.marginLeft
    );
    this.$scope.$applyAsync();
    this.displayAttachmentName =
      this.attachment && !this.attachment.thumb && this.attachment.mimetype !== 'text/html';

    if (this.isImage()) {
      const {
        width: w = 0,
        height: h = 0,
        large: src,
        loadSize,
        loadEffectiveSize,
      } = this.attachment;
      this.attachmentsCtrl.photoswipeGallery.addItem({ src, w, h, raw_image_url: this.src });

      const { width: loadedWidth, height: loadedHeight } = await loadSize;
      this.attachmentsCtrl.photoswipeGallery.updateItem({ src, w: loadedWidth, h: loadedHeight });

      const { effectiveHeight } = await loadEffectiveSize;
      this.attachmentsCtrl.updateAttachmentEffectiveHeight(this.index, effectiveHeight);
    }
  }

  isVideo() {
    return this.attachment.mimetype.indexOf('video/') === 0;
  }

  isImage() {
    return this.attachment.mimetype.indexOf('image/') === 0;
  }

  openModal(content) {
    return this.$uibModal
      .open({
        size: 'lg',
        scope: this.$scope,
        template: `<div class="modal-body text-center">${content}</div>`,
      })
      .result.ignoreCancel();
  }

  attachmentClicked(event) {
    if (this.isImage()) {
      this.attachmentsCtrl.photoswipeGallery.open(this.index);
      event.preventDefault();
      return;
    }

    const openInline = this.total === 1 && this.isVideo();
    const { thumbWidth: width, thumbHeight: height } = this.attachment;
    const getModalHtmlArgs = openInline ? [width, height] : [];
    const embed = this.AttachmentUtils.getModalHtml(this.attachment, ...getModalHtmlArgs);

    if (embed && openInline) {
      const embedTrusted = this.$sce.trustAsHtml(embed);
      this.inlineVideo = embedTrusted;
      this.inlineVideoStyle = { width: `${width}px`, height: `${height}px` };
      event.preventDefault();
      return;
    }

    if (embed) {
      this.openModal(embed);
      event.preventDefault();
    }
  }
}

export default {
  bindings: {
    src: '<',
    total: '<',
    index: '<',
    width: '<',
    arbitraryHeight: '<',
  },
  require: {
    attachmentsCtrl: '^attachments',
  },
  templateUrl: attachmentUrl,
  controller: AttachmentCtrl,
  controllerAs: 'ctrl',
};
